<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
  @import '~flatpickr/dist/flatpickr.css';
  @import '~flatpickr/dist/plugins/monthSelect/style.css';
  @import '~vue-multiselect/dist/vue-multiselect.min.css';
</style>
